import { render } from "./PartnerSearch.vue?vue&type=template&id=05c4ae34&scoped=true"
import script from "./PartnerSearch.vue?vue&type=script&lang=js"
export * from "./PartnerSearch.vue?vue&type=script&lang=js"

import "./PartnerSearch.vue?vue&type=style&index=0&id=05c4ae34&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c4ae34"]])

export default __exports__